import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HistoryComponent as ViewHistoryComponent } from './view/history/history.component';
import { IndexComponent as ViewIndexComponent } from './view/index/index.component';
import { LoginComponent as ViewLoginComponent } from './view/login/login.component';
import { TransactionComponent as ViewTransactionComponent } from './view/transaction/transaction.component';
import { OpenIdGuard } from './guard/open-id.guard';
import { OperatorRoleGuard } from './guard/operator-role.guard';
import { UsersComponent as ViewUsersComponent } from './view/users/users.component';
import { PendingComponent as ViewPendingComponent } from './view/pending/pending.component';
import { FeesComponent as ViewFeesComponent } from './view/fees/fees.component';
import { ConfigComponent as ViewConfigComponent } from './view/config/config.component';
import { TokenComponent as ViewLoginTokenComponent } from './view/login/token/token.component';
import { SubscriptionsComponent as ViewSubscriptionsComponent } from './view/subscriptions/subscriptions.component';
import { PlansComponent as ViewSubscriptionsPlansComponent } from './view/subscriptions/plans/plans.component';
import { DetailComponent as ViewSubscriptionsPlansDetailComponent } from './view/subscriptions/plans/detail/detail.component';
import { TiersComponent as ViewSubscriptionsPlansTiersComponent } from './view/subscriptions/plans/tiers/tiers.component';
import { TierComponent as ViewSubscriptionsPlansTiersTierComponent } from './view/subscriptions/plans/tiers/tier/tier.component';

const routes: Routes = [
    { path: '', component: ViewIndexComponent, canActivate: [OpenIdGuard] },
    {
        path: 'config',
        component: ViewConfigComponent,
        canActivate: [OpenIdGuard, OperatorRoleGuard],
    },
    {
        path: 'fees',
        component: ViewFeesComponent,
        canActivate: [OpenIdGuard, OperatorRoleGuard],
    },
    {
        path: 'history',
        component: ViewHistoryComponent,
        canActivate: [OpenIdGuard],
    },
    { path: 'login', component: ViewLoginComponent },
    { path: 'login/token', component: ViewLoginTokenComponent },
    {
        path: 'pending',
        component: ViewPendingComponent,
        canActivate: [OpenIdGuard],
    },
    {
        path: 'subscriptions',
        component: ViewSubscriptionsComponent,
        canActivate: [OpenIdGuard],
    },
    {
        path: 'subscriptions-plans',
        component: ViewSubscriptionsPlansComponent,
        canActivate: [OpenIdGuard],
    },
    {
        path: 'subscriptions-plans/:id',
        component: ViewSubscriptionsPlansDetailComponent,
        canActivate: [OpenIdGuard],
    },
    {
        path: 'subscriptions-plans/:id/tiers',
        component: ViewSubscriptionsPlansTiersComponent,
        canActivate: [OpenIdGuard],
    },
    {
        path: 'subscriptions-plans/:id/tiers/:tier',
        component: ViewSubscriptionsPlansTiersTierComponent,
        canActivate: [OpenIdGuard],
    },

    {
        path: 'transaction',
        component: ViewTransactionComponent,
        canActivate: [OpenIdGuard],
    },
    {
        path: 'users',
        component: ViewUsersComponent,
        canActivate: [OpenIdGuard, OperatorRoleGuard],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
